import React, { useRef } from "react";
import {
  Leaf,
  Heart,
  Shield,
  Sun,
  ThermometerSun,
  Home,
  Moon,
  Wind,
  Sparkle,
} from "lucide-react";

const EnergyEfficientShades = () => {
  const whatWeOfferRef = useRef(null);
  
  const scrollToSection = () => {
    if (whatWeOfferRef.current) {
      whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      {/* <section
  className="text-center object-cover h-screen bg-cover bg-center"
  style={{ backgroundImage: "url('images/energy.jpg')" }}
>
  <div className="px-4 sm:px-8 md:px-16 lg:px-28">
    <h1 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-9xl font-Montserrat uppercase font-semibold mb-4 text-left pl-2 sm:pl-10 lg:pl-20 pt-60 xl:pt-20 text-[#060606]">
      ELEVATE
    </h1>

    <h1 className="text-5xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-9xl font-Montserrat uppercase font-semibold mb-4 text-left pr-2 sm:pr-10 lg:pr-20 text-[#060606]">
      COMFORT & EFFICIENCY
    </h1>
  </div>

  <div className="flex justify-start mt-8 pl-2 sm:pl-10 lg:pl-32">
    <button onClick={scrollToSection} className="text-white bg-[#060606] text-sm sm:text-base md:text-lg lg:text-xl px-4 sm:px-6 lg:px-8 py-2 sm:py-3 lg:py-4 rounded">
      LEARN MORE
    </button>
  </div>
</section> */}

<section 
   className="object-cover h-screen bg-cover bg-center flex flex-col  items-center  pt-40 md:pt-20 "
   style={{ backgroundImage: "url('images/energy.jpg')" }}
 >
  <div className="">
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#484646] font-Montserrat uppercase  mb-4  lg:text-8xl ">
    ROOM 
    </h1>
    <h1 className="text-4xl md:text-8xl 2xl:text-[130px] font-semibold text-[#484646] font-Montserrat uppercase  mb-4  lg:text-8xl">
      DARKENING
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  ">
    <button onClick={scrollToSection} className="text-black bg-[#ffffff] 2xltext-xl w-40 2xl:w-48 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>
      {/* Features Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 ref={whatWeOfferRef} className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12">
            Why Choose Aura Shades
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: <Sun className="w-8 h-8" />,
                title: "Light Control",
                description: "Perfect balance of natural light with precision control",
              },
              {
                icon: <ThermometerSun className="w-8 h-8" />,
                title: "Energy Efficient",
                description: "Reduce energy costs with superior insulation",
              },
              {
                icon: <Shield className="w-8 h-8" />,
                title: "UV Protection",
                description: "Protect your furniture from harmful UV rays",
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center"
              >
                <div className="inline-block p-3 bg-blue-50 rounded-full mb-4 text-blue-600">
                  {feature.icon}
                </div>
                <h3 className="text-lg sm:text-xl font-semibold mb-3">
                  {feature.title}
                </h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Showcase Section */}
      <section className="py-16 px-4">
  <div className="max-w-6xl mx-auto">
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-12">
      Our Collection
    </h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      {[
        {
          image: "images/landing.png",
          title: "Roller Blinds",
          description: "Sleek and modern design for any room",
        },
        {
          image: "images/landing4.png",
          title: "Venetian Blinds",
          description: "Classic style with modern functionality",
        },
      ].map((item, index) => (
        <div
          key={index}
          className="group relative overflow-hidden rounded-lg"
        >
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-64 md:h-[400px] object-cover transition-transform group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent flex items-end">
            <div className="p-6 text-white">
              <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-2">
                {item.title}
              </h3>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl">
                {item.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>


      {/* Smart Features Section */}
      <section className="py-16 px-4 bg-gray-900 text-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-12">
            Smart Features
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: <Home className="w-6 h-6" />,
                title: "Smart Home Integration",
              },
              {
                icon: <Sun className="w-6 h-6" />,
                title: "Automated Light Sensing",
              },
              {
                icon: <Moon className="w-6 h-6" />,
                title: "Schedule Setting",
              },
              {
                icon: <Wind className="w-6 h-6" />,
                title: "Climate Control",
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="text-center p-6 border border-gray-700 rounded-lg"
              >
                <div className="inline-block p-3 bg-white/10 rounded-full mb-4">
                  {feature.icon}
                </div>
                <h3 className="text-base sm:text-lg font-semibold">
                  {feature.title}
                </h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <Sparkle className="w-12 h-12 mx-auto mb-6 text-blue-600" />
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
            Transform Your Space Today
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 mb-8">
            Book a consultation with our design experts
          </p>
          <button className="bg-blue-600 text-white px-6 sm:px-8 py-2 sm:py-3 rounded-full text-base sm:text-lg font-semibold hover:bg-blue-700 transition-colors">
            Contact Us
          </button>
        </div>
      </section>
    </div>
  );
};

export default EnergyEfficientShades;
